interface EmptyCircleProps {
    noOfCircles: number;
    children?: React.ReactNode;
  }
  
  const EmptyCircle = ({ noOfCircles, children }: EmptyCircleProps) => {
    return (
      <div className="relative w-[400px] h-[400px] flex justify-center items-center">
        {Array.from({ length: noOfCircles }, (_, index) => {
          const size = 80 + index * 40; // Increasing size for each circle
          return (
            <div
              key={index}
              className="absolute border border-gray-200 rounded-full"
              style={{
                width: `${size}px`,
                height: `${size}px`,
              }}
            ></div>
          );
        })}
        {/* Center icon */}
        <div className="flex flex-col items-center justify-center z-10">
          {children}
        </div>
      </div>
    );
  };
  
  interface IEmptyStateCircleProps {
    noOfCircles?: number;
    children?: React.ReactNode;
    className?: string;
  }
  
  const EmptyStateCircle = ({
    noOfCircles = 7,
    children,
    className = "",
  }: IEmptyStateCircleProps) => {
    return (
      <div className={`flex justify-center ${className}`}>
        <EmptyCircle noOfCircles={noOfCircles}>{children}</EmptyCircle>
      </div>
    );
  };
  
  export default EmptyStateCircle;
  